import { mergeAttributes } from '@tiptap/core'
import { Link } from '@tiptap/extension-link'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    'custom-link': {
      /**
       * Set a link mark
       */
      setLink: (attributes: { href: string; target?: string }) => ReturnType
      /**
       * Toggle a link mark
       */
      toggleLink: (attributes: { href: string; target?: string }) => ReturnType
      /**
       * Unset a link mark
       */
      unsetLink: () => ReturnType
      /**
       * Insert a link
       */
      insertLink: (attributes: {
        href: string
        text?: string
        target?: string
      }) => ReturnType
    }
  }
}

export const CustomLink = Link.extend({
  name: 'custom-link',
  addOptions() {
    return {
      ...this.parent?.(),
      autolink: false,
    }
  },
  addCommands() {
    return {
      ...this.parent?.(),
      insertLink:
        ({ href, target = '_blank', text }) =>
        ({ commands }) => {
          return commands.insertContent(
            `<a href="${href}" class="text-interactive hover:text-interactive-hovered" target=${target}>${
              text || href
            }</a>`,
          )
        },
    }
  },
  renderHTML({ HTMLAttributes }) {
    const { class: _discardingExistingClasses, ...anchorAttributes } =
      HTMLAttributes
    return [
      'a',
      mergeAttributes(anchorAttributes, {
        class: 'text-interactive hover:text-interactive-hovered',
      }),
      0,
    ]
  },
})
